import React from 'react';
import CustomTag from '../../../../../components/CustomTag';
import Truncate from '../../../../../components/Truncate';
import './styles.css';

const Name = ({ tag = 'h2', children }) => {
  return (
    <CustomTag tag={tag} className="Listview__Card__name">
      <Truncate lines={2}>
        <span>{children}</span>
      </Truncate>
    </CustomTag>
  );
};

export default Name;
